import { type UseControllerProps, useCustomController } from '@faceup/form'
import { FormItem, Scale } from '@faceup/ui'
import type { AFForm_itemFragment } from '../../__generated__/graphql'

type ScaleInputProps = UseControllerProps & {
  item: Extract<AFForm_itemFragment, { __typename: 'AF_FormItemScale' }>
}

export const AFScaleFormInput = ({ item, ...props }: ScaleInputProps) => {
  const { formItemProps, inputProps } = useCustomController(props)

  const translatedOptions = item.options.map(option => {
    return {
      id: option.id,
      label: option.translation.translation,
      isActive: (inputProps.value as string | undefined) === option.id,
    }
  })

  return (
    <FormItem {...formItemProps} notClickableLabel>
      <input
        style={{ width: 0, height: 0, visibility: 'hidden', position: 'absolute' }}
        readOnly
        tabIndex={-1}
      />
      <Scale
        startLabel={item.startLabelTranslation?.translation}
        endLabel={item.endLabelTranslation?.translation}
        onChange={values => {
          inputProps.onChange(values[0] ?? '')
        }}
        options={translatedOptions}
      />
    </FormItem>
  )
}
